import Dashboard from "views/Dashboard/Dashboard.jsx";
import ClinicRoles from "views/Roles/Clinic/ClinicRolesList.jsx";
import ClinicRoleView from "views/Roles/Clinic/ClinicRoleView.jsx";
import UserRoles from "views/Roles/User/UserRolesList.jsx";
import UserRoleAdd from "views/Roles/User/UserRoleAdd.jsx";
import UserRoleView from "views/Roles/User/UserRoleView.jsx";
import UserRoleUpdate from "views/Roles/User/UserRoleUpdate.jsx";
import ClinicRoleAdd from "views/Roles/Clinic/ClinicRoleAdd.jsx";
import ClinicRoleUpdate from "views/Roles/Clinic/ClinicRoleUpdate.jsx";
import ViewProfile from "views/Profile/viewProfile.jsx";
import JDLeadsList from "views/Marketing/JDLeadsList.jsx";
import GetPaymentList from "views/Payment/GetPaymentList.jsx";
import Campaign from "views/Marketing/Campaign.jsx";
import CampaignsList from "views/Marketing/CampaignsList.jsx";
import ReCampaign from "views/Marketing/RerunCampaign.jsx";
import CampaignEdit from "views/Marketing/CampaignEdit.jsx";
import PrintFile from "views/PrintFile/PrintFile.jsx";
import PrintFileReport from "views/PrintFile/PrintFileReport.jsx";
import Support from "views/Support/index.jsx";
import InitiatePayment from "views/Payment/InitiatePayment.jsx";
// import GoogleMaps from "views/Maps/GoogleMaps.jsx";
// import FullScreenMap from "views/Maps/FullScreenMap.jsx";
// import VectorMap from "views/Maps/VectorMap.jsx";
// import Widgets from "views/Widgets/Widgets.jsx";
import UserProfile from "views/Pages/UserProfile.jsx";
import TimelinePage from "views/Pages/Timeline.jsx";
import RTLSupport from "views/Pages/RTLSupport.jsx";
import ClinicMaster from "views/ClinicMasters/ClinicMasters.jsx";
import addClinicMaster from "views/ClinicMasters/addClinicMaster.jsx";
import oneClinicMaster from "views/ClinicMasters/oneClinicMaster.jsx";
import updateClinicMaster from "views/ClinicMasters/updateClinicMaster.jsx";
import Clinic from "views/Clinics/Clinics.jsx";
import addClinic from "views/Clinics/addClinic.jsx";
import updateClinic from "views/Clinics/updateClinic.jsx";
import oneClinic from "views/Clinics/oneClinic.jsx";
import Doctor from "views/Doctors/Doctors.jsx";
import Patient from "views/Patients/Patients.jsx";
import onePatient from "views/Patients/onePatient.jsx";
import updatePatient from "views/Patients/updatePatientTS.jsx";
import oneDoctor from "views/Doctors/oneDoctor.jsx";
import addDoctor from "views/Doctors/addDoctor.jsx";
import addPatient from "views/Patients/addPatient.jsx";
import updateDoctorTS from "views/Doctors/updateDoctorTS.jsx";
import PartnerReports from "views/PartnerReports/Reports.jsx";
import OnePartnerReports from "views/PartnerReports/oneReport.jsx";
import PartnerPatient from "views/PartnerReports/Patients.jsx";
import AddPartnerReportsDrag from "views/PartnerReports/AddReportsDrag.jsx";
import Reports from "views/Reports/Reports.jsx";
import AddReports from "views/Reports/AddReports.jsx";
import CreateReport from "views/Reports/CreateReport.jsx";
import AddReportsDrag from "views/Reports/AddReportsDrag.jsx";
import ReportsBatchDrag from "views/Reports/ReportsBatchDrag.jsx";
import BatchReports from "views/Reports/BatchReports.jsx";
import UpdateReports from "views/Reports/UpdateReports.jsx";
import OneReport from "views/Reports/oneReport.jsx";
import BookAppointment from "views/Appointments/Book.jsx";
import BookPackagesAppointment from "views/Appointments/BookPackages.jsx";
import Appointments from "views/Appointments/Appointments.jsx";
import OneAppointment from "views/Appointments/oneAppointment.jsx";
import OneAppointmentRequest from "views/Appointments/oneAppointmentRequest.jsx";
import UpdateAppointment from "views/Appointments/updateAppointment.jsx";
import AppointmentCalendar from "views/Appointments/appointmentCalendar.jsx";
import AppointmentRequests from "views/Appointments/appointmentRequests.jsx";
import Analytics from "views/Analytics/Analytics.jsx";
import ReportAnalytics from "views/ReportAnalytics/Analytics.jsx";
import OtpAnalytics from "views/OtpAnalytics/Analytics.jsx";
import Packages from "views/Packages/Packages.jsx";
import MasterPackages from "views/Packages/MasterPackages.jsx";
import AddPackage from "views/Packages/AddPackage.jsx";
import AddMasterPackage from "views/Packages/AddMasterPackage.jsx";
import OnePackage from "views/Packages/OnePackage.jsx";
import OneMasterPackage from "views/Packages/OneMasterPackage.jsx";
import UpdatePackage from "views/Packages/UpdatePackage.jsx";
import UpdateMasterPackage from "views/Packages/UpdateMasterPackage.jsx";
import PackagesRequests from "views/Packages/packagesRequests.jsx";
import OnePackageRequest from "views/Packages/onePackageRequest.jsx";
import CreatePrescription from "views/Prescription/CreatePrescription.jsx";
import Prescriptions from "views/Prescription/Prescription.jsx";
import OnePrescription from "views/Prescription/OnePrescription.jsx";
import CreateBilling from "views/Billing/CreateBilling.jsx";
import AllClinicalNotes from "views/Data/AllClinicalNotes.jsx";
import AllClinicalMedication from "views/Data/AllClinicalMedication.jsx";
import AllPrescriptionTemplate from "views/Data/AllPrescriptionTemplate.jsx";
import AllReportTemplate from "views/Data/AllReportTemplate.jsx";
import AllReportConfig from "views/Data/AllReportConfig.jsx";
import Billing from "views/Billing/Billing.jsx";
import OneBill from "views/Billing/OneBill.jsx";
import Intents from "views/Intent/Intents.jsx";
import CreateIntent from "views/Intent/CreateIntent.jsx";
import Tests from "views/Tests/Tests.jsx";
import MasterTests from "views/Tests/MasterTests.jsx";
import AddTest from "views/Tests/AddTest.jsx";
import AddMasterTest from "views/Tests/AddMasterTest.jsx";
import OneTest from "views/Tests/OneTest.jsx";
import OnePayment from "views/Payment/OnePayment.jsx";
import OneMasterTest from "views/Tests/OneMasterTest.jsx";
import UpdateTest from "views/Tests/UpdateTest.jsx";
import UpdateMasterTest from "views/Tests/UpdateMasterTest.jsx";
import RequestsTest from "views/Tests/testRequests.jsx";
import OneTestRequest from "views/Tests/oneTestRequest.jsx";
import TestMapping from "views/Tests/testMapping.jsx";
import TestMappingEdit from "views/Tests/testMappingEdit.jsx";
import BookTestsAppointment from "views/Tests/BookTest.jsx";
import Reviews from "views/Reviews/Reviews.jsx";
import Notifications from "views/Notifications/Notifications.jsx";
import AddNotifications from "views/Notifications/addNotifications.jsx";

import pagesRoutes from "./pages.jsx";
import {mappingUI, isHealthSpaceUser} from '../util/globalHelper';
import Permissions from '../util/globalPermissions';

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import GridOn from "@material-ui/icons/GridOn";
import Person from "@material-ui/icons/Person";
import Business from "@material-ui/icons/Business";
import Store from "@material-ui/icons/Store";
import Hospital from "@material-ui/icons/LocalHospital";
import WidgetsIcon from "@material-ui/icons/Widgets";
import DateRange from "@material-ui/icons/DateRange";
import Assignment from "@material-ui/icons/Assignment";
import AnalyticsIcon from "@material-ui/icons/TrendingUp";
import GroupIcon from "@material-ui/icons/Group";
// import FileUpload from "@material-ui/icons/FileUpload";
import PersonAdd from "@material-ui/icons/PersonAdd";
import MoneyOn from "@material-ui/icons/Payment";
import Money from "@material-ui/icons/ShoppingCart";
import TableChart from "@material-ui/icons/Dvr";
import SupportIcon from "@material-ui/icons/Announcement";
import FolderSpecial from "@material-ui/icons/FolderSpecial";
import Analytical from "@material-ui/icons/Equalizer";
import Mktg from "@material-ui/icons/LocalOffer";
import Loyalty from "@material-ui/icons/Loyalty";
import Inbox from "@material-ui/icons/Inbox";

var pages = [
    {
        path: "/timeline-page",
        name: "Timeline Page",
        mini: "TP",
        component: TimelinePage
    },
    {
        path: "/user-page",
        name: "User Profile",
        mini: "UP",
        component: UserProfile
    },
    {
        path: "/rtl/rtl-support-page",
        name: "RTL Support",
        mini: "RS",
        component: RTLSupport
    }
].concat(pagesRoutes);

var dashRoutes = [
    {
        path: "/dashboard",
        name: "Dashboard",
        icon: DashboardIcon,
        component: Dashboard
    },
    mappingUI(Permissions.ViewMaster) ?
        {
            path: "/clinicmaster/readClinicMasters",
            name: "Clinic Masters",
            icon: Business,
            component: ClinicMaster,
        } : null,
    mappingUI(Permissions.ViewClinics) ?
        {
            path: "/clinic/readClinics",
            name: "Clinics",
            icon: Store,
            component: Clinic
        } : null,
    mappingUI(Permissions.ViewDoctors) ?

        {
            path: "/doctor/readDoctors",
            name: "Doctors",
            icon: Hospital,
            component: Doctor
        } : null,
    mappingUI(Permissions.ViewPatients) ?
        {
            path: "/patient/readPatients",
            name: "Patients",
            icon: Person,
            component: Patient
        } : null,
    mappingUI(Permissions.ViewReports) ?
        {
            path: "/report/readReports",
            name: "Reports",
            icon: Assignment,
            component: Reports,
        } : null,
    {
        path: "/report/adddrag",
        name: "Add Report",
        icon: Assignment,
        component: AddReportsDrag,
    },


    {
        collapse: true,
        path: "/roles",
        name: "More Reports",
        state: "openReports",
        icon: Assignment,
        views: [
            {
                path: "/report/createReport",
                name: "Report Editor",
                mini: "RE",
                component: CreateReport,
            },
            {
                path: "/prescription/readPrescription",
                name: "Prescriptions",
                mini: "PS",
                component: Prescriptions,
            },
            {
                path: "/prescription/createPrescription",
                name: "Create Prescription",
                mini: "CP",
                component: CreatePrescription,
            }
            , {
                path: "/billing/readBilling",
                name: "Bills",
                mini: "BL",
                component: Billing,
            }, {
                path: "/billing/createBilling",
                name: "Create Bills",
                mini: "CB",
                component: CreateBilling,
            }
        ]
    },



    

    {
        collapse: true,
        path: "/roles",
        name: "Partner Reports",
        state: "openPartners",
        icon: GroupIcon,
        views: [
            {
                path: "/report/createCustomReport",
                name: "View Partner Reports",
                mini: "VR",
                component: PartnerReports,
            }, 
            {
                path: "/custom/patients",
                name: "Partner Patients",
                mini: "VPP",
                component: PartnerPatient,
            }
        ]
    },

    mappingUI(Permissions.ViewAppointments) ?
        {
            collapse: true,
            path: "/appointment/readAppointments",
            name: "Appointments",
            state: "openAppointments",
            icon: DateRange,
            views: [
                {
                    path: "/appointment/bookAppointment",
                    name: "Book Appointment",
                    icon: WidgetsIcon,
                    component: BookAppointment,
                },
                {
                    path: "/appointment/readAppointments",
                    name: "View Appointments",
                    mini: "VA",
                    component: Appointments
                },
                {
                    path: "/appointment/calendar",
                    name: "Appointment Calendar",
                    icon: WidgetsIcon,
                    mini: "AC",
                    component: AppointmentCalendar,
                },
                {
                    path: "/appointment/requests",
                    name: `Appointment Requests (${localStorage.getItem("requestList") ? JSON.parse(localStorage.getItem("requestList")).length : 0})`,
                    mini: "AR",
                    component: AppointmentRequests,
                },
                {
                    path: "/appointment/packages/book",
                    name: `Book Packages`,
                    mini: "BP",
                    component: BookPackagesAppointment,
                }
            ]
        } : null,
    /*mappingUI(Permissions.ViewAppointments) ?
     {
     path: "/appointment/readAppointments",
     name: "Appointment",
     icon: WidgetsIcon,
     component: Appointments,
     } : null,
     mappingUI(Permissions.ViewAppointments) ?
     {
     path: "/appointment/calendar",
     name: "Appointment Calendar",
     icon: WidgetsIcon,
     component: AppointmentCalendar,
     } : null,
     mappingUI(Permissions.ApprovAappointments) ?
     {
     path: "/appointment/requests",
     name: `Appointment Requests (${localStorage.getItem("requestList") ? JSON.parse(localStorage.getItem("requestList")).length : 0})`,
     icon: WidgetsIcon,
     component: AppointmentRequests,
     } : null,*/
    /*mappingUI(Permissions.ViewAnalytics) ?
        {
            path: "/analytics",
            name: "Analytics",
            icon: AnalyticsIcon,
            component: Analytics,
        } : null,
    mappingUI(Permissions.ViewAnalytics) ?
        {
            path: "/otp-analytics",
            name: "Otp Analytics",
            icon: AnalyticsIcon,
            component: OtpAnalytics,
        } : null,
    mappingUI(Permissions.ViewAnalytics) ?
        {
            path: "/report-analytics",
            name: "Report Analytics",
            icon: AnalyticsIcon,
            component: ReportAnalytics,
        } : null,*/
    {
        path: "/reviews",
        name: "Reviews",
        icon: AnalyticsIcon,
        component: Reviews,
    },
    isHealthSpaceUser() ? {
        collapse: true,
        path: "/payment",
        name: "Payments",
        state: "openPayment",
        icon: MoneyOn,
        views: [
            {
                path: "/payment/list",
                name: "All Payments",
                mini: "AP",
                component: GetPaymentList
            }, {
                path: "/payment/initiate",
                name: "Generate Payment",
                mini: "GP",
                component: InitiatePayment
            }
        ]
    } : null,
    isHealthSpaceUser() ? {
        collapse: true,
        path: "/packages",
        name: "Packages",
        state: "openPackages",
        icon: FolderSpecial,
        views: [
            {
                path: "/packages/master/all",
                name: "Master Packages",
                mini: "MP",
                component: MasterPackages
            }, {
                path: "/packages/master/add",
                name: "Add Master Package",
                mini: "AMP",
                component: AddMasterPackage
            }, {
                path: "/packages/all",
                name: "Clinic Packages",
                mini: "AP",
                component: Packages
            },
            {
                path: "/packages/add",
                name: "Add Package",
                mini: "AP",
                component: AddPackage
            },
            {
                path: "/packages/requests",
                name: `Packages Requests`,
                mini: "PR",
                component: PackagesRequests,
            },
        ]
    } : null,
    isHealthSpaceUser() ? {
        collapse: true,
        path: "/tests",
        name: "Tests",
        state: "openTests",
        icon: Money,
        views: [
            {
                path: "/tests/book",
                name: "Book Test",
                mini: "BT",
                component: BookTestsAppointment
            }, {
                path: "/tests/master/all",
                name: "Master Tests",
                mini: "MT",
                component: MasterTests
            },
            {
                path: "/tests/master/add",
                name: "Add Master Test",
                mini: "AMT",
                component: AddMasterTest
            }, {
                path: "/tests/all",
                name: "Clinic Tests",
                mini: "CT",
                component: Tests
            },
            {
                path: "/tests/add",
                name: "Add Clinic Test",
                mini: "AT",
                component: AddTest
            },
            {
                path: "/tests/request",
                name: "Test Request",
                mini: "AT",
                component: RequestsTest
            },
            {
                path: "/tests/mapping/edit",
                name: "Test Mapping Edit",
                mini: "TME",
                component: TestMappingEdit
            }, {
                path: "/tests/mapping",
                name: "Test Mapping",
                mini: "TM",
                component: TestMapping
            }
        ]
    } : null,    

    mappingUI(Permissions.ViewAnalytics) ? {
        collapse: true,
        path: "/analytics",
        name: "Analytics",
        state: "openAnalytics",
        icon: Analytical,
        views: [
                {
                path: "/analytics",
                name: "View Analytics",
                mini: "VA",
                component: Analytics,
            }, {
                path: "/otp-analytics",
                name: "Otp Analytics",
                mini: "OA",
                component: OtpAnalytics,
            }, {
                path: "/report-analytics",
                name: "Report Analytics",
                mini: "RA",
                component: ReportAnalytics,
            }
        ]
    } : null,
    
    isHealthSpaceUser() ? {
        collapse: true,
        path: "/marketing",
        name: "Marketing",
        state: "openMarketing",
        icon: Loyalty,
        views: [
            {
                path: "/marketing/jdleads",
                name: "Just Dial Leads",
                mini: "JDL",
                component: JDLeadsList
            },
            {
                path: "/marketing/campaign",
                name: "Campaign",
                mini: "MC",
                component: Campaign
            }, {
                path: "/marketing/list",
                name: "Campaign List",
                mini: "CL",
                component: CampaignsList
            }, {
                path: "/marketing/notification/list",
                name: "Notifications List",
                mini: "NL",
                component: Notifications
            }
        ]
    } : null,
    {
        path: "/report/batchupload",
        name: "Batch Report Upload",
        icon: Assignment,
        component: ReportsBatchDrag,
    }, {
        path: "/report/getbatchfiles",
        name: "Batch Report View",
        icon: Inbox,
        component: BatchReports,
    },
    {
        collapse: true,
        path: "/data",
        name: "Data",
        state: "openData",
        icon: TableChart,
        views: [
            {
                path: "/data/clinicalNotes",
                name: "Clinical Notes",
                mini: "ACN",
                component: AllClinicalNotes
            },
            {
                path: "/data/clinicalMedication",
                name: "Clinical Medication",
                mini: "ACM",
                component: AllClinicalMedication
            },
            {
                path: "/data/prescriptionTemplate",
                name: "Prescription Template",
                mini: "PT",
                component: AllPrescriptionTemplate
            },
            {
                path: "/data/reportTemplate",
                name: "Report Template",
                mini: "RT",
                component: AllReportTemplate
            },
            {
                path: "/data/reportConfig",
                name: "Report Config",
                mini: "RC",
                component: AllReportConfig
            }
        ]
    },


    {
        collapse: true,
        path: "/roles",
        name: "Users",
        state: "openTables",
        icon: GroupIcon,
        views: [
            {
                path: "/roles/user",
                name: "View Users",
                mini: "VU",
                component: UserRoles
            },
            {
                path: "/roles/clinic",
                name: "View Roles",
                mini: "VR",
                component: ClinicRoles
            }
        ]
    },

    {
        path: "/intent/all",
        name: "Clinic Requests",
        icon: PersonAdd,
        component: Intents,
    }, {
        path: "/support",
        name: "Support",
        icon: SupportIcon,
        component: Support,
    },
    // {
    //     collapse: true,
    //     path: "-page",
    //     name: "Pages",
    //     state: "openPages",
    //     icon: Image,
    //     views: pages
    // },
    // {
    //     collapse: true,
    //     path: "/components",
    //     name: "Components",
    //     state: "openComponents",
    //     icon: Apps,
    //     views: [
    //         {
    //             path: "/components/buttons",
    //             name: "Buttons",
    //             mini: "B",
    //             component: Buttons
    //         },
    //         {
    //             path: "/components/grid-system",
    //             name: "Grid System",
    //             mini: "GS",
    //             component: GridSystem
    //         },
    //         {
    //             path: "/components/panels",
    //             name: "Panels",
    //             mini: "P",
    //             component: Panels
    //         },
    //         {
    //             path: "/components/sweet-alert",
    //             name: "Sweet Alert",
    //             mini: "SA",
    //             component: SweetAlert
    //         },
    //         {
    //             path: "/components/notifications",
    //             name: "Notifications",
    //             mini: "N",
    //             component: Notifications
    //         },
    //         {path: "/components/icons", name: "Icons", mini: "I", component: Icons},
    //         {
    //             path: "/components/typography",
    //             name: "Typography",
    //             mini: "T",
    //             component: Typography
    //         }
    //     ]
    // },
    // {
    //     collapse: true,
    //     path: "/forms",
    //     name: "Forms",
    //     state: "openForms",
    //     icon: ContentPaste,
    //     views: [
    //         {
    //             path: "/forms/regular-forms",
    //             name: "Regular Forms",
    //             mini: "RF",
    //             component: RegularForms
    //         },
    //         {
    //             path: "/forms/extended-forms",
    //             name: "Extended Forms",
    //             mini: "EF",
    //             component: ExtendedForms
    //         },
    //         {
    //             path: "/forms/validation-forms",
    //             name: "Validation Forms",
    //             mini: "VF",
    //             component: ValidationForms
    //         },
    //         {path: "/forms/wizard", name: "Wizard", mini: "W", component: Wizard}
    //     ]
    // },
    // {
    //     collapse: true,
    //     path: "/tables",
    //     name: "Tables",
    //     state: "openTables",
    //     icon: GridOn,
    //     views: [
    //         {
    //             path: "/tables/regular-tables",
    //             name: "Regular Tables",
    //             mini: "RT",
    //             component: RegularTables
    //         },
    //         {
    //             path: "/tables/extended-tables",
    //             name: "Extended Tables",
    //             mini: "ET",
    //             component: ExtendedTables
    //         },
    //         {
    //             path: "/tables/react-tables",
    //             name: "React Tables",
    //             mini: "RT",
    //             component: ReactTables
    //         }
    //     ]
    // },
    // {
    //   collapse: true,
    //   path: "/maps",
    //   name: "Maps",
    //   state: "openMaps",
    //   icon: Place,
    //   views: [
    //     {
    //       path: "/maps/google-maps",
    //       name: "Google Maps",
    //       mini: "GM",
    //       component: GoogleMaps
    //     },
    //     {
    //       path: "/maps/full-screen-maps",
    //       name: "Full Screen Map",
    //       mini: "FSM",
    //       component: FullScreenMap
    //     },
    //     {
    //       path: "/maps/vector-maps",
    //       name: "Vector Map",
    //       mini: "VM",
    //       component: VectorMap
    //     }
    //   ]
    // },
    {
        path: "/clinicmaster/add",
        name: "Add ClinicMaster",
        component: addClinicMaster,
        invisible: true
    },
    {
        path: "/clinicmaster/oneClinicMaster/:clinicmasterID",
        name: "Clinic Master View",
        component: oneClinicMaster,
        invisible: true
    },
    {
        path: "/clinicmaster/updateClinicMaster/:clinicmasterID",
        name: "Update ClinicMaster",
        component: updateClinicMaster,
        invisible: true
    },
    {
        path: "/clinic/addClinic/:clinicmasterID",
        name: "Add Clinic",
        icon: WidgetsIcon,
        component: addClinic,
        invisible: true
    },
    {
        path: "/clinic/addClinic",
        name: "Add Clinic",
        icon: WidgetsIcon,
        component: addClinic,
        invisible: true
    },
    {
        path: "/clinic/updateClinic/:clinicID",
        name: "Update Clinic",
        icon: WidgetsIcon,
        component: updateClinic,
        invisible: true
    },
    {
        path: "/clinic/oneClinic/:clinicID",
        name: "Clinic View",
        icon: WidgetsIcon,
        component: oneClinic,
        invisible: true
    }, {
        path: "/intent/create",
        name: "Create Intent",
        icon: WidgetsIcon,
        component: CreateIntent,
        invisible: true
    },
    {
        path: "/patient/addPatient",
        name: "Add Patient",
        icon: WidgetsIcon,
        component: addPatient,
        invisible: true
    },
    {
        path: "/patient/updatePatient/:patientID",
        name: "Update Patient",
        icon: WidgetsIcon,
        component: updatePatient,
        invisible: true
    },
    {
        path: "/patient/:patientID",
        name: "One Patient",
        icon: WidgetsIcon,
        component: onePatient,
        invisible: true
    },

    {
        path: "/doctor/addDoctor/:clinicmasterID/:clinicID",
        name: "Add Doctor",
        icon: WidgetsIcon,
        component: addDoctor,
        invisible: true
    },
    {
        path: "/doctor/addDoctor",
        name: "Add Doctor",
        icon: WidgetsIcon,
        component: addDoctor,
        invisible: true
    },
    {
        path: "/doctor/oneDoctor/:doctorID",
        name: "One Doctor",
        icon: WidgetsIcon,
        component: oneDoctor,
        invisible: true
    },
    {
        path: "/doctor/updateDoctorDetails/:doctorID/:clinicID",
        name: "Update Doctor",
        icon: WidgetsIcon,
        component: updateDoctorTS,
        invisible: true
    },
    {
        path: "/doctor/updateDoctorDetails/:doctorID",
        name: "Update Doctor",
        icon: WidgetsIcon,
        component: updateDoctorTS,
        invisible: true
    },
    {
        path: "/doctor/updateDoctorClinic",
        name: "Update Doctor",
        icon: WidgetsIcon,
        component: updateDoctorTS,
        invisible: true
    },
    {
        path: "/clinic/role/view/:id",
        name: "Clinic Master",
        icon: WidgetsIcon,
        component: ClinicRoleView,
        invisible: true
    },
    {
        path: "/user/role/add",
        name: "User Role Add",
        icon: WidgetsIcon,
        component: UserRoleAdd,
        invisible: true
    },
    {
        path: "/user/role/clinicmaster/:clinicMasterID/:id",
        name: "User Role View",
        icon: WidgetsIcon,
        component: UserRoleView,
        invisible: true
    },
    {
        path: "/user/role/update/clinicmaster/:clinicMasterID/:id",
        name: "User Role View",
        icon: WidgetsIcon,
        component: UserRoleUpdate,
        invisible: true
    },
    {
        path: "/clinic/role/add",
        name: "Clinic Role Add",
        icon: WidgetsIcon,
        component: ClinicRoleAdd,
        invisible: true
    },
    {
        path: "/clinic/role/update/:clinicMasterID/:id",
        name: "Clinic Role Update",
        icon: WidgetsIcon,
        component: ClinicRoleUpdate,
        invisible: true
    },
    {
        path: "/appointment/bookAppointment/:patientID",
        name: "Book Appointment",
        icon: WidgetsIcon,
        component: BookAppointment,
        invisible: true
    },
    {
        path: "/appointment/bookAppointment",
        name: "Book Appointment",
        icon: WidgetsIcon,
        component: BookAppointment,
        invisible: true
    },
    {
        path: "/appointment/book/schedule/:DateTime",
        name: "Book Appointment",
        icon: WidgetsIcon,
        component: BookAppointment,
        invisible: true
    },
    {
        path: "/appointment/view/:id",
        name: "Add Report",
        icon: WidgetsIcon,
        component: OneAppointment,
        invisible: true
    },
    {
        path: "/appointment/request/view/:id",
        name: "View Appointment Request",
        icon: WidgetsIcon,
        component: OneAppointmentRequest,
        invisible: true
    }, {
        path: "/package/request/view/:id",
        name: "View Package Request",
        icon: WidgetsIcon,
        component: OnePackageRequest,
        invisible: true
    }, {
        path: "/test/request/view/:id",
        name: "View Test Request",
        icon: WidgetsIcon,
        component: OneTestRequest,
        invisible: true
    },
    {
        path: "/appointment/update/:id",
        name: "Add Report",
        icon: WidgetsIcon,
        component: UpdateAppointment,
        invisible: true
    },
    {
        path: "/appointment/calendar",
        name: "Appointment Calendar",
        icon: WidgetsIcon,
        component: AppointmentCalendar,
        invisible: true
    },
    {
        path: "/report/add/:patientID",
        name: "Add Report",
        icon: WidgetsIcon,
        component: AddReports,
        invisible: true
    },
    {
        path: "/report/add",
        name: "Add Report",
        icon: WidgetsIcon,
        component: AddReports,
        invisible: true
    },
    {
        path: "/report/adddrag",
        name: "Add Report",
        icon: WidgetsIcon,
        component: AddReportsDrag,
        invisible: true
    }, {
        path: "/report/custom/add",
        name: "Add Report",
        icon: WidgetsIcon,
        component: AddPartnerReportsDrag,
        invisible: true
    },
    {
        path: "/report/view/:id",
        name: "View Report",
        icon: WidgetsIcon,
        component: OneReport,
        invisible: true
    },
    {
        path: "/report/custom/view/:id",
        name: "View Report",
        icon: WidgetsIcon,
        component: OnePartnerReports,
        invisible: true
    },
    {
        path: "/report/update/:id",
        name: "Add Report",
        icon: WidgetsIcon,
        component: UpdateReports,
        invisible: true
    },
    {
        path: "/packages/view/:id",
        name: "View Package",
        icon: WidgetsIcon,
        component: OnePackage,
        invisible: true
    }, {
        path: "/packages/master/view/:id",
        name: "View Package",
        icon: WidgetsIcon,
        component: OneMasterPackage,
        invisible: true
    },
    {
        path: "/packages/master/update/:id",
        name: "Update Package",
        icon: WidgetsIcon,
        component: UpdateMasterPackage,
        invisible: true
    }, {
        path: "/packages/update/:id",
        name: "Update Package",
        icon: WidgetsIcon,
        component: UpdatePackage,
        invisible: true
    },
    {
        path: "/tests/view/:id",
        name: "View Test",
        icon: WidgetsIcon,
        component: OneTest,
        invisible: true
    }, {
        path: "/payment/view/:id",
        name: "View Payment",
        icon: WidgetsIcon,
        component: OnePayment,
        invisible: true
    }, {
        path: "/tests/master/view/:id",
        name: "View Test",
        icon: WidgetsIcon,
        component: OneMasterTest,
        invisible: true
    },
    {
        path: "/tests/master/update/:id",
        name: "Update Test",
        icon: WidgetsIcon,
        component: UpdateMasterTest,
        invisible: true
    }, {
        path: "/tests/update/:id",
        name: "Update Test",
        icon: WidgetsIcon,
        component: UpdateTest,
        invisible: true
    }, {
        path: "/prescription/view/:id",
        name: "View Prescription",
        icon: WidgetsIcon,
        component: OnePrescription,
        invisible: true
    }, {
        path: "/bill/view/:id",
        name: "View Bill",
        icon: WidgetsIcon,
        component: OneBill,
        invisible: true
    },
    {
        path: "/myprofile",
        name: "My Profile",
        icon: WidgetsIcon,
        component: ViewProfile,
        invisible: true
    },
    {
        path: "/marketing/recampaign/:id",
        name: "Re-Campaign",
        mini: "RC",
        component: ReCampaign,
        invisible: true
    }, {
        path: "/marketing/notifications/add",
        name: "Add Notifications",
        mini: "AN",
        component: AddNotifications,
        invisible: true
    },
    {
        path: "/marketing/edit/campaign/:id",
        name: "Edit Campaign",
        mini: "EC",
        component: CampaignEdit,
        invisible: true
    },
    {
        path: "/print/prescription/:id",
        name: "Print Prescription File",
        icon: WidgetsIcon,
        component: PrintFile,
        invisible: true
    }, {
        path: "/print/report/:id",
        name: "Print Report File",
        icon: WidgetsIcon,
        component: PrintFileReport,
        invisible: true
    },
    // {path: "/charts", name: "Charts", icon: Timeline, component: Charts},
    // {path: "/calendar", name: "Calendar", icon: DateRange, component: Calendar},
    // {redirect: true, path: "/", pathTo: "/dashboard", name: "Dashboard"}
];
export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx